import { MAX_EXPORT_DECIMAL_PLACES } from '../constants';
import { DecimalPlacesIssue, ExportColumnRoundingMode } from '../types';
import resolveNonNegativeInteger from './resolveNonNegativeInteger';

const resolveDecimalPlacesIssue = (
  decimalPlaces: string,
  roundingMode: ExportColumnRoundingMode
): DecimalPlacesIssue | null => {
  const trimmedValue = decimalPlaces.trim();

  // Without rounding the value never reaches the export, so it must not be reported.
  if (roundingMode === 'none' || trimmedValue === '') {
    return null;
  }

  if (Number.isNaN(Number(trimmedValue))) {
    return 'notANumber';
  }

  const parsedValue = resolveNonNegativeInteger(trimmedValue);

  // Mirrors what resolveRoundedValue accepts, so the error state and the rounding never disagree.
  if (parsedValue === undefined) {
    return 'invalid';
  }

  return parsedValue > MAX_EXPORT_DECIMAL_PLACES ? 'outOfRange' : null;
};

export default resolveDecimalPlacesIssue;
